import React from "react";

export const DashboardIcon = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 17.4444C0 18.549 0.895431 19.4444 2 19.4444H13.5556C14.6601 19.4444 15.5556 18.549 15.5556 17.4444V2C15.5556 0.895429 14.6601 0 13.5556 0H2C0.895432 0 0 0.895431 0 2V17.4444ZM0 33C0 34.1046 0.895431 35 2 35H13.5556C14.6601 35 15.5556 34.1046 15.5556 33V25.3333C15.5556 24.2288 14.6601 23.3333 13.5556 23.3333H2C0.895432 23.3333 0 24.2288 0 25.3333V33ZM19.4444 33C19.4444 34.1046 20.3399 35 21.4444 35H33C34.1046 35 35 34.1046 35 33V17.5556C35 16.451 34.1046 15.5556 33 15.5556H21.4444C20.3399 15.5556 19.4444 16.451 19.4444 17.5556V33ZM21.4444 0C20.3399 0 19.4444 0.89543 19.4444 2V9.66666C19.4444 10.7712 20.3399 11.6667 21.4444 11.6667H33C34.1046 11.6667 35 10.7712 35 9.66667V2C35 0.895432 34.1046 0 33 0H21.4444Z"
      fill="#F3F3F3"
    />
  </svg>
);
export const ReportIcon = (
  <svg
    width="28"
    height="35"
    viewBox="0 0 28 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.6777 1.91782H20.8274C19.8114 0.744365 18.314 0 16.6455 0H11.1084C9.43988 0 7.94254 0.744365 6.92651 1.91782H3.07617C1.37997 1.91782 0 3.30053 0 5.00001V31.9178C0 33.6173 1.37997 35 3.07617 35H24.6777C26.3739 35 27.7539 33.6173 27.7539 31.9178V5.00001C27.7539 3.30046 26.3739 1.91782 24.6777 1.91782ZM11.1084 2.05481H16.6455C18.2299 2.05481 19.5457 3.11541 19.978 4.52054H7.77588C8.2075 3.11787 9.52157 2.05481 11.1084 2.05481ZM25.7031 31.9178C25.7031 32.4843 25.2431 32.9452 24.6777 32.9452H3.07617C2.51077 32.9452 2.05078 32.4843 2.05078 31.9178V5.00001C2.05078 4.43352 2.51077 3.97264 3.07617 3.97264H5.80002C5.64831 4.484 5.57127 5.01459 5.57129 5.54798C5.57129 6.11536 6.03039 6.57535 6.59668 6.57535H21.1572C21.7235 6.57535 22.1826 6.11536 22.1826 5.54798C22.1826 5.01459 22.1056 4.484 21.9539 3.97264H24.6777C25.2431 3.97264 25.7031 4.43352 25.7031 5.00001V31.9178Z"
      fill="#F3F3F3"
    />
    <path
      d="M8.8225 20.4155L7.31449 21.9264L6.94576 21.557C6.54538 21.1557 5.8961 21.1557 5.49565 21.557C5.0952 21.9582 5.0952 22.6087 5.49565 23.0099L6.5894 24.1058C6.98978 24.507 7.63906 24.507 8.03951 24.1058L10.2725 21.8683C10.673 21.4671 10.673 20.8166 10.2725 20.4154C9.87215 20.0142 9.22288 20.0142 8.8225 20.4155ZM21.4649 21.2333H13.1934C12.6271 21.2333 12.168 21.6933 12.168 22.2607C12.168 22.828 12.6271 23.288 13.1934 23.288H21.4649C22.0312 23.288 22.4903 22.828 22.4903 22.2607C22.4903 21.6933 22.0312 21.2333 21.4649 21.2333ZM8.8225 26.3059L7.31449 27.8168L6.94576 27.4474C6.54538 27.0461 5.8961 27.0461 5.49565 27.4474C5.0952 27.8486 5.0952 28.4991 5.49565 28.9003L6.5894 29.9961C6.98978 30.3973 7.63906 30.3974 8.03951 29.9961L10.2725 27.7587C10.673 27.3575 10.673 26.707 10.2725 26.3058C9.87215 25.9046 9.22288 25.9046 8.8225 26.3059ZM21.4649 27.1237H13.1934C12.6271 27.1237 12.168 27.5837 12.168 28.1511C12.168 28.7184 12.6271 29.1784 13.1934 29.1784H21.4649C22.0312 29.1784 22.4903 28.7184 22.4903 28.1511C22.4903 27.5837 22.0312 27.1237 21.4649 27.1237ZM15.8325 16.4803L19.0039 13.3026V13.4251C19.0039 13.9925 19.463 14.4525 20.0293 14.4525C20.5956 14.4525 21.0547 13.9925 21.0547 13.4251C21.0547 10.5189 21.0595 10.7895 21.043 10.6747C20.9704 10.1721 20.5403 9.79479 20.029 9.79492H17.4317C16.8654 9.79492 16.4063 10.2549 16.4063 10.8223C16.4063 11.3897 16.8654 11.8497 17.4317 11.8497H17.5538L15.1075 14.3008L12.0044 11.1917C11.604 10.7904 10.9547 10.7904 10.5542 11.1917L6.86284 14.8904C6.46239 15.2916 6.46239 15.9421 6.86284 16.3433C7.26322 16.7445 7.9125 16.7445 8.31294 16.3433L11.2793 13.3711L14.3824 16.4803C14.7828 16.8815 15.4321 16.8815 15.8325 16.4803Z"
      fill="#F3F3F3"
    />
  </svg>
);
export const backBtnIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    fill="currentColor"
  >
    <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" />
  </svg>
);
export const LogoutIcon = (
  <svg
    width="20"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2222 1H10.7778V13.2222H13.2222V1ZM19.1256 3.65222L17.39 5.38778C19.3211 6.94 20.5556 9.32333 20.5556 12C20.5556 16.73 16.73 20.5556 12 20.5556C7.27 20.5556 3.44444 16.73 3.44444 12C3.44444 9.32333 4.67889 6.94 6.59778 5.37556L4.87444 3.65222C2.50333 5.66889 1 8.65111 1 12C1 18.0744 5.92556 23 12 23C18.0744 23 23 18.0744 23 12C23 8.65111 21.4967 5.66889 19.1256 3.65222Z"
      fill="#FF0000"
      stroke="#FF0000"
      strokeWidth="0.5"
    />
  </svg>
);

export const CopyTextIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
      stroke="#125B48"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReloadIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 11C2 15.9706 6.02944 20 11 20C13.3051 20 15.4077 19.1334 17 17.7083L20 15M20 15V20M20 15H15M20 11C20 6.02944 15.9706 2 11 2C8.69494 2 6.59227 2.86656 5 4.29168L2 7M2 7V2M2 7H7"
      stroke="#FF0000"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshIcon = (
  <svg
    width="20"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 2V7.55555M22 7.55555H16.4445M22 7.55555L18.6666 4.54631C16.8975 2.96285 14.5612 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22C16.7591 22 20.7416 18.6755 21.7522 14.2222"
      stroke="#FF0000"
      strokeWidth="3.2"
    />
  </svg>
);

export const ExportIcon = (
  <svg
    width="20"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.164 8.28076H14.5113V10.4087H18.164C19.2503 10.4087 20.093 10.9534 20.093 11.4223V20.8582C20.093 21.3271 19.2503 21.8718 18.164 21.8718H4.35709C3.27088 21.8718 2.42812 21.3271 2.42812 20.8582V11.4226C2.42812 10.9538 3.27088 10.409 4.35709 10.409H8.00912V8.2811H4.35709C2.06003 8.2811 0.260742 9.66109 0.260742 11.4226V20.8586C0.260742 22.6205 2.06003 24.0002 4.35709 24.0002H18.1644C20.4611 24.0002 22.2607 22.6202 22.2607 20.8586V11.4226C22.2604 9.66071 20.4611 8.28076 18.164 8.28076Z"
      fill="#FF0000"
    />
    <path
      d="M8.05377 5.30388C8.33122 5.30388 8.60828 5.19996 8.81992 4.99212L10.1767 3.66004V8.28049V10.4084V14.4848C10.1767 15.0725 10.6618 15.5488 11.2604 15.5488C11.8589 15.5488 12.3441 15.0725 12.3441 14.4848V10.4084V8.28049V3.58805L13.7742 4.99212C13.9859 5.19996 14.2633 5.30388 14.5404 5.30388C14.8175 5.30388 15.0949 5.19996 15.3065 4.99212C15.7299 4.57682 15.7299 3.90298 15.3065 3.48768L12.071 0.311033C11.8593 0.103205 11.5823 0 11.3052 0C11.3023 0 11.2998 0 11.2969 0C11.294 0 11.2915 0 11.2886 0C11.0115 0 10.7344 0.103205 10.5228 0.311033L7.28723 3.48768C6.86389 3.90298 6.86389 4.57682 7.28723 4.99212C7.49926 5.19996 7.77637 5.30388 8.05377 5.30388Z"
      fill="#FF0000"
    />
  </svg>
);

export const CameraIcon = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 13V5C19 3.89543 18.1046 3 17 3H14.5C13.9477 3 13.5 2.55228 13.5 2C13.5 1.44772 13.0523 1 12.5 1H7.5C6.94772 1 6.5 1.44772 6.5 2C6.5 2.55228 6.05228 3 5.5 3H3C1.89543 3 1 3.89543 1 5V13C1 14.1046 1.89543 15 3 15H17C18.1046 15 19 14.1046 19 13Z"
      stroke="black"
      strokeWidth="1.8"
    />
    <path
      d="M13 9C13 10.6569 11.6569 12 10 12C8.3431 12 7 10.6569 7 9C7 7.3431 8.3431 6 10 6C11.6569 6 13 7.3431 13 9Z"
      stroke="black"
      strokeWidth="1.8"
    />
  </svg>
);

export const CameraFillIcon = (
  <svg
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_108_45)">
      <path
        d="M32.5761 8.84784H28.7152L26.5837 5.63045C25.7794 4.42393 24.3718 3.70001 22.9239 3.70001H14.0761C12.6283 3.70001 11.2207 4.42393 10.4163 5.63045L8.2848 8.84784H4.42393C3.8425 8.84616 3.26648 8.95944 2.72899 9.18117C2.1915 9.40289 1.70314 9.72869 1.29201 10.1398C0.880874 10.551 0.555075 11.0393 0.333348 11.5768C0.11162 12.1143 -0.00166128 12.6903 1.84089e-05 13.2718V28.8761C-0.00166128 29.4575 0.11162 30.0335 0.333348 30.571C0.555075 31.1085 0.880874 31.5969 1.29201 32.008C1.70314 32.4192 2.1915 32.745 2.72899 32.9667C3.26648 33.1884 3.8425 33.3017 4.42393 33.3H32.5761C33.1575 33.3017 33.7336 33.1884 34.2711 32.9667C34.8085 32.745 35.2969 32.4192 35.708 32.008C36.1192 31.5969 36.445 31.1085 36.6667 30.571C36.8884 30.0335 37.0017 29.4575 37 28.8761V13.2718C37.0017 12.6903 36.8884 12.1143 36.6667 11.5768C36.445 11.0393 36.1192 10.551 35.708 10.1398C35.2969 9.72869 34.8085 9.40289 34.2711 9.18117C33.7336 8.95944 33.1575 8.84616 32.5761 8.84784ZM18.5 29.6804C12.9902 29.6804 8.52611 25.2163 8.52611 19.7065C8.52611 14.1968 12.9902 9.77284 18.5 9.77284C24.0098 9.77284 28.4739 14.237 28.4739 19.7467C28.4739 25.2163 24.0098 29.6804 18.5 29.6804ZM32.0131 15.0815H30.2435C29.5196 15.0413 28.9565 14.4381 28.9968 13.7141C29.037 13.0304 29.5598 12.5076 30.2435 12.4674H31.8522C32.5761 12.4272 33.1794 12.9902 33.2196 13.7141C33.2598 14.4381 32.737 15.0413 32.0131 15.0815Z"
        fill="#125b48"
      />
      <path
        d="M18.5001 14.1967C15.4436 14.1967 12.9501 16.6902 12.9501 19.7467C12.9501 22.8033 15.4436 25.2565 18.5001 25.2565C21.5566 25.2565 24.0501 22.7631 24.0501 19.7065C24.0501 16.65 21.5566 14.1967 18.5001 14.1967Z"
        fill="#125b48"
      />
    </g>
    <defs>
      <clipPath id="clip0_108_45">
        <rect width="37" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ConvertIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M15.0002 22.7483C14.7302 22.7483 14.4802 22.5983 14.3502 22.3683C14.2202 22.1283 14.2202 21.8483 14.3602 21.6083L15.4102 19.8583C15.6202 19.4983 16.0902 19.3883 16.4402 19.5983C16.8002 19.8083 16.9102 20.2683 16.7002 20.6283L16.4302 21.0783C19.1902 20.4283 21.2602 17.9483 21.2602 14.9883C21.2602 14.5783 21.6002 14.2383 22.0102 14.2383C22.4202 14.2383 22.7602 14.5783 22.7602 14.9883C22.7502 19.2683 19.2702 22.7483 15.0002 22.7483Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M2 9.75C1.59 9.75 1.25 9.41 1.25 9C1.25 4.73 4.73 1.25 9 1.25C9.27 1.25 9.52 1.4 9.65 1.63C9.78 1.87 9.78 2.15 9.64 2.39L8.59 4.14C8.38 4.49 7.92 4.61 7.56 4.39C7.21 4.18 7.09 3.72 7.31 3.36L7.58 2.91C4.81 3.56 2.75 6.04 2.75 9C2.75 9.41 2.41 9.75 2 9.75Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M14.8 12.6292V15.5692C14.8 18.0192 13.82 18.9992 11.37 18.9992H8.43C5.98 18.9992 5 18.0192 5 15.5692V12.6292C5 10.1792 5.98 9.19922 8.43 9.19922H11.37C13.82 9.19922 14.8 10.1792 14.8 12.6292Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M15.5709 5H12.6309C10.2209 5 9.24094 5.96 9.21094 8.32H11.3709C14.3109 8.32 15.6709 9.69 15.6709 12.62V14.78C18.0409 14.75 18.9909 13.77 18.9909 11.36V8.43C19.0009 5.98 18.0209 5 15.5709 5Z"
        fill="#FFFFFF"
      ></path>
    </g>
  </svg>
);

export const PortalIcon = (
  <svg
    width="32"
    height="35"
    viewBox="0 0 32 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 3.5H27.25C26.6977 3.5 26.25 3.05228 26.25 2.5V1C26.25 0.447715 25.8023 0 25.25 0H23.75C23.1977 0 22.75 0.447715 22.75 1V2.5C22.75 3.05228 22.3023 3.5 21.75 3.5H9.75C9.19772 3.5 8.75 3.05228 8.75 2.5V1C8.75 0.447715 8.30228 0 7.75 0H6.25C5.69772 0 5.25 0.447715 5.25 1V2.5C5.25 3.05228 4.80228 3.5 4.25 3.5H3.5C1.5575 3.5 0.0175 5.075 0.0175 7L0 31.5C0 33.425 1.5575 35 3.5 35H28C29.925 35 31.5 33.425 31.5 31.5V7C31.5 5.075 29.925 3.5 28 3.5ZM28 30.5C28 31.0523 27.5523 31.5 27 31.5H4.5C3.94771 31.5 3.5 31.0523 3.5 30.5V13.25C3.5 12.6977 3.94772 12.25 4.5 12.25H27C27.5523 12.25 28 12.6977 28 13.25V30.5ZM7 16.75C7 16.1977 7.44772 15.75 8 15.75H14.75C15.3023 15.75 15.75 16.1977 15.75 16.75V23.5C15.75 24.0523 15.3023 24.5 14.75 24.5H8C7.44772 24.5 7 24.0523 7 23.5V16.75Z"
      fill="#F3F3F3"
    />
  </svg>
);

export const BackArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    fill="currentColor"
  >
    <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" />
  </svg>
);

export const ExcelDownloadIcon = (
  <svg
    width="53"
    height="63"
    viewBox="0 0 53 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.98493 0C8.46848 0 7.23926 1.41024 7.23926 3.15V59.85C7.23926 61.5898 8.46848 63 9.98493 63H50.2549C51.7714 63 53.0006 61.5898 53.0006 59.85V10.5L43.8484 0H9.98493Z"
      fill="#ECEDEF"
    />
    <path
      d="M46.5933 10.5H52.9999L43.8477 0V7.34996C43.8477 9.08972 45.0769 10.5 46.5933 10.5Z"
      fill="#D9DCDF"
    />
    <path
      d="M42.0179 5.25H7.23926V24.15H42.0179C42.5234 24.15 42.9331 23.6798 42.9331 23.1V6.29996C42.9331 5.72004 42.5233 5.25 42.0179 5.25Z"
      fill="#C6CACF"
    />
    <path
      d="M40.1856 22.0514H1.21004C0.394699 22.0514 -0.0137203 20.9204 0.562872 20.2589L7.23744 12.6014L0.562872 4.94379C-0.0137203 4.28229 0.394699 3.15137 1.21004 3.15137H40.1856C40.691 3.15137 41.1007 3.62153 41.1007 4.20133V21.0013C41.1009 21.5812 40.691 22.0514 40.1856 22.0514Z"
      fill="#529E44"
    />
    <path
      d="M43.8454 27.3008H16.3887V32.5508H43.8454V27.3008Z"
      fill="#FF9785"
    />
    <path
      d="M34.6952 38.8508V32.5508H25.543V38.8508V45.1508H43.8475V38.8508H34.6952Z"
      fill="#A1D1EA"
    />
    <path
      d="M43.8466 26.25H27.3725C26.867 26.25 26.4573 26.7202 26.4573 27.3C26.4573 27.8799 26.8671 28.3499 27.3725 28.3499H42.9314V31.5H17.305V28.35H22.7963C23.3018 28.35 23.7115 27.8799 23.7115 27.3001C23.7115 26.7202 23.3017 26.2501 22.7963 26.2501H16.3898C15.8843 26.2501 15.4746 26.7203 15.4746 27.3001V56.7C15.4746 57.28 15.8844 57.75 16.3898 57.75H34.6943C35.1998 57.75 35.6095 57.2798 35.6095 56.7V46.2001H43.8466C44.3521 46.2001 44.7618 45.7299 44.7618 45.1501V27.3001C44.7618 26.7202 44.3521 26.25 43.8466 26.25ZM42.9313 37.8H35.6094V33.6001H42.9313V37.8ZM17.305 46.2001H24.6268V50.4H17.305V46.2001ZM17.305 44.1V39.9001H24.6268V44.1H17.305ZM26.4572 39.9001H33.779V44.1H26.4572V39.9001ZM26.4572 37.8V33.6001H33.779V37.8H26.4572ZM24.6268 33.6001V37.8H17.305V33.6001H24.6268ZM17.305 52.5001H24.6268V55.6501H17.305V52.5001ZM26.4572 52.5001H33.779V55.6501H26.4572V52.5001ZM33.779 50.4H26.4572V46.2001H33.779V50.4ZM35.6095 39.9001H42.9314V44.1H35.6095V39.9001Z"
      fill="#7B848F"
    />
    <path
      d="M41.391 51.975L43.6261 48.9834C43.955 48.543 43.9106 47.8803 43.5268 47.5028C43.1429 47.1254 42.5652 47.1764 42.2362 47.6167L40.1854 50.3615L38.1346 47.6167C37.8056 47.1764 37.2279 47.1254 36.844 47.5028C36.4603 47.8801 36.4158 48.543 36.7447 48.9834L38.9801 51.975L36.7451 54.9667C36.4484 55.3637 36.4561 55.9692 36.7628 56.3564C37.1281 56.8172 37.7819 56.8057 38.1349 56.3333L40.1857 53.5885L42.2365 56.3333C42.59 56.8063 43.2425 56.8162 43.6087 56.3564C43.916 55.9702 43.9225 55.3632 43.6264 54.9667L41.391 51.975Z"
      fill="#529E44"
    />
    <path
      d="M31.9509 12.6001H30.1204V11.5501H31.9509C32.4564 11.5501 32.8661 11.08 32.8661 10.5002C32.8661 9.92036 32.4563 9.4502 31.9509 9.4502H29.2052C28.6997 9.4502 28.29 9.92036 28.29 10.5002V13.6502C28.29 14.2301 28.6999 14.7001 29.2052 14.7001H31.0357V15.7501H29.2052C28.6997 15.7501 28.29 16.2202 28.29 16.8C28.29 17.3798 28.6999 17.85 29.2052 17.85H31.9509C32.4564 17.85 32.8661 17.3798 32.8661 16.8V13.65C32.8662 13.0702 32.4565 12.6001 31.9509 12.6001Z"
      fill="white"
    />
    <path
      d="M26.4607 15.7502H24.6302V10.5002C24.6302 9.92023 24.2204 9.4502 23.715 9.4502C23.2095 9.4502 22.7998 9.92036 22.7998 10.5002V16.8002C22.7998 17.3801 23.2096 17.8501 23.715 17.8501H26.4607C26.9662 17.8501 27.3759 17.38 27.3759 16.8002C27.3759 16.2204 26.9663 15.7502 26.4607 15.7502Z"
      fill="white"
    />
    <path
      d="M21.553 9.69359C21.1647 9.32236 20.5876 9.38253 20.264 9.82796L18.679 12.01L17.094 9.82796C16.7704 9.38253 16.1933 9.32236 15.8049 9.69359C15.4167 10.065 15.3641 10.7269 15.6878 11.1725L17.4876 13.6503L15.6878 16.1281C15.3925 16.5348 15.4117 17.1505 15.7334 17.5307C16.107 17.9724 16.7507 17.945 17.0941 17.4724L18.6791 15.2904L20.2641 17.4724C20.6075 17.945 21.2511 17.9724 21.6248 17.5307C21.9463 17.1505 21.9656 16.5346 21.6704 16.1281L19.8705 13.6503L21.6704 11.1725C21.9936 10.7268 21.9413 10.0648 21.553 9.69359Z"
      fill="white"
    />
  </svg>
);
export const PDFDownloadIcon = (
  <svg
    width="440"
    height="512"
    viewBox="0 0 440 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M439.435 117.825V512H11.791V0.00195312H321.613L376.491 54.881L439.435 117.825Z"
      fill="#FFFEFE"
    />
    <path d="M205.662 34.295H0.56543V126.063H205.662V34.295Z" fill="#B43331" />
    <path
      d="M74.1333 64.379C73.2283 62.193 72.0223 60.233 70.3643 58.575C68.7053 56.917 66.6703 55.56 64.3333 54.655C61.9213 53.675 59.2063 53.223 56.1923 53.223H33.6523V111.418H45.0353V89.481H56.1923C59.2073 89.481 61.9213 89.029 64.3333 88.049C66.6703 87.144 68.7043 85.788 70.3643 84.129C72.0223 82.471 73.2293 80.586 74.1333 78.325C74.9613 76.139 75.4143 73.802 75.4143 71.39C75.4133 68.902 74.9613 66.565 74.1333 64.379ZM61.8453 77.118C60.3373 78.55 58.2273 79.304 55.6633 79.304H45.0353V63.323H55.6633C58.2273 63.323 60.3373 64.077 61.8453 65.584C63.2773 67.016 64.0303 68.976 64.0303 71.388C64.0313 73.726 63.2773 75.686 61.8453 77.118Z"
      fill="#FFFEFE"
    />
    <path
      d="M128.558 75.761C128.483 73.726 128.408 71.917 128.181 70.258C127.956 68.599 127.578 67.092 127.05 65.66C126.523 64.303 125.844 62.946 124.939 61.74C122.904 58.8 120.417 56.614 117.627 55.257C114.763 53.9 111.371 53.222 107.375 53.222H86.4199V111.417H107.376C111.372 111.417 114.764 110.739 117.628 109.382C120.418 108.025 122.905 105.839 124.94 102.899C125.845 101.693 126.524 100.336 127.051 98.979C127.579 97.547 127.956 96.039 128.182 94.381C128.409 92.723 128.483 90.913 128.559 88.878C128.634 86.918 128.634 84.732 128.634 82.32C128.633 79.908 128.633 77.721 128.558 75.761ZM117.175 88.2C117.175 89.934 117.025 91.291 116.873 92.497C116.722 93.628 116.497 94.683 116.195 95.437C115.894 96.266 115.441 97.02 114.914 97.698C113.029 100.11 110.165 101.241 106.396 101.241H97.7279V63.323H106.396C110.165 63.323 113.03 64.529 114.914 66.941C115.442 67.619 115.894 68.298 116.195 69.127C116.497 69.956 116.723 70.936 116.873 72.142C117.025 73.273 117.175 74.705 117.175 76.363C117.25 78.022 117.25 80.057 117.25 82.318C117.251 84.581 117.251 86.541 117.175 88.2Z"
      fill="#FFFEFE"
    />
    <path
      d="M177.181 63.323V53.222H138.811V111.417H150.194V87.823H173.186V77.646H150.194V63.323H177.181Z"
      fill="#FFFEFE"
    />
    <path
      d="M74.1333 64.379C73.2283 62.193 72.0223 60.233 70.3643 58.575C68.7053 56.917 66.6703 55.56 64.3333 54.655C61.9213 53.675 59.2063 53.223 56.1923 53.223H33.6523V111.418H45.0353V89.481H56.1923C59.2073 89.481 61.9213 89.029 64.3333 88.049C66.6703 87.144 68.7043 85.788 70.3643 84.129C72.0223 82.471 73.2293 80.586 74.1333 78.325C74.9613 76.139 75.4143 73.802 75.4143 71.39C75.4133 68.902 74.9613 66.565 74.1333 64.379ZM61.8453 77.118C60.3373 78.55 58.2273 79.304 55.6633 79.304H45.0353V63.323H55.6633C58.2273 63.323 60.3373 64.077 61.8453 65.584C63.2773 67.016 64.0303 68.976 64.0303 71.388C64.0313 73.726 63.2773 75.686 61.8453 77.118Z"
      fill="#FFFEFE"
    />
    <path
      opacity="0.08"
      d="M439.435 117.825V512H11.791V419.581L211.706 219.667L223.541 207.832L230.099 201.273L241.029 190.343L253.995 177.377L376.491 54.881L439.435 117.825Z"
      fill="#040000"
    />
    <path d="M439.436 117.836H321.601V0L439.436 117.836Z" fill="#BBBBBA" />
    <path
      d="M378.377 370.658C375.889 366.286 372.497 362.14 368.276 358.371C364.809 355.205 360.738 352.265 356.139 349.551C337.596 338.621 311.136 333.344 275.178 333.344H271.559C269.599 331.535 267.564 329.726 265.454 327.841C251.81 315.554 240.954 302.211 232.511 287.361C249.094 250.8 257.011 218.235 256.031 190.494C255.88 185.82 255.2 181.448 253.994 177.377C252.186 170.819 249.171 165.014 244.949 160.265C244.874 160.19 244.874 160.19 244.799 160.114C238.09 152.576 228.742 148.279 219.243 148.279C209.669 148.279 200.85 152.425 194.441 160.039C188.11 167.577 184.718 177.905 184.567 190.041C184.342 208.585 185.849 226.149 189.015 242.356C189.316 243.638 189.543 244.919 189.844 246.2C193.01 260.9 197.684 274.845 203.715 287.811C196.629 302.209 189.467 314.647 184.493 323.09C180.724 329.498 176.577 336.207 172.28 342.916C152.907 346.384 136.473 350.605 122.151 355.882C102.777 362.893 87.2475 371.938 76.0915 382.718C68.8535 389.653 63.9545 397.041 61.5415 404.73C58.9785 412.645 59.1305 420.56 61.9945 427.646C64.6325 434.204 69.3815 439.707 75.7135 443.476C77.2215 444.381 78.8045 445.134 80.4625 445.813C85.2875 447.773 90.5645 448.828 96.0665 448.828C108.807 448.828 121.923 443.325 133.005 433.45C153.659 414.981 174.993 385.281 187.581 366.51C197.908 364.927 209.139 363.57 221.804 362.213C236.731 360.705 249.922 359.801 261.908 359.348C265.602 362.665 269.145 365.831 272.538 368.846C291.384 385.656 305.707 397.793 318.673 406.311C318.673 406.386 318.748 406.386 318.823 406.386C323.95 409.778 328.849 412.567 333.749 414.829C339.251 417.392 344.83 418.749 350.559 418.749C357.796 418.749 364.58 416.563 370.234 412.568C375.963 408.422 380.109 402.467 381.994 395.758C384.182 387.694 382.9 378.724 378.377 370.658ZM211.706 219.667C210.65 210.319 210.199 200.595 210.35 190.343C210.5 180.619 214.044 174.06 219.245 174.06C223.164 174.06 227.311 177.603 229.196 184.387C229.724 186.422 230.1 188.759 230.175 191.397C230.325 194.563 230.251 197.88 230.101 201.272C229.649 210.846 227.988 221.022 225.124 231.953C223.39 238.964 221.129 246.276 218.34 253.889C215.173 243.186 212.911 231.803 211.706 219.667ZM85.9685 418.073C84.6865 414.907 86.1185 408.801 93.9585 401.263C105.943 389.805 124.714 380.759 150.873 373.899C145.897 380.683 140.998 386.865 136.248 392.518C129.011 401.262 122.076 408.65 115.819 414.228C110.468 419.052 104.587 422.068 99.0085 422.822C98.0285 422.973 97.0485 423.048 96.0685 423.048C91.1695 423.049 87.1735 421.089 85.9685 418.073ZM206.428 337.942L206.956 337.113L206.128 337.264C206.278 336.887 206.505 336.51 206.73 336.209C209.897 330.857 213.891 323.997 218.188 316.082L218.564 316.911L219.545 314.876C222.711 319.399 226.178 323.847 229.796 328.143C231.531 330.178 233.341 332.138 235.149 334.098L233.943 334.173L234.998 335.153C231.908 335.379 228.667 335.681 225.425 335.982C223.389 336.208 221.279 336.359 219.169 336.585C214.797 337.037 210.499 337.49 206.428 337.942ZM333.299 384.98C324.329 379.251 314.301 371.185 301.938 360.405C319.502 362.214 333.299 366.059 343.098 371.788C347.395 374.276 350.636 376.839 352.822 379.326C356.441 383.17 357.723 386.638 357.043 388.975C356.441 391.312 353.802 392.895 350.56 392.895C348.675 392.895 346.716 392.443 344.681 391.463C341.213 389.805 337.595 387.769 333.75 385.282C333.599 385.282 333.449 385.131 333.299 384.98Z"
      fill="#B43331"
    />
  </svg>
);
export const DateIcon = (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2 1.8C15.7029 1.8 15.3 1.39706 15.3 0.9C15.3 0.402944 14.8971 0 14.4 0C13.9029 0 13.5 0.402944 13.5 0.9C13.5 1.39706 13.0971 1.8 12.6 1.8H5.4C4.90294 1.8 4.5 1.39706 4.5 0.9C4.5 0.402944 4.09706 0 3.6 0C3.10294 0 2.7 0.402944 2.7 0.9C2.7 1.39706 2.29706 1.8 1.8 1.8C0.81 1.8 0 2.61 0 3.6V18C0 18.99 0.81 19.8 1.8 19.8H16.2C17.19 19.8 18 18.99 18 18V3.6C18 2.61 17.19 1.8 16.2 1.8ZM16.2 16C16.2 17.1046 15.3046 18 14.2 18H3.8C2.69543 18 1.8 17.1046 1.8 16V8.3C1.8 7.19543 2.69543 6.3 3.8 6.3H14.2C15.3046 6.3 16.2 7.19543 16.2 8.3V16Z"
      fill="#115b48"
    />
  </svg>
);
export const DateIcon2 = (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2 1.8C15.7029 1.8 15.3 1.39706 15.3 0.9C15.3 0.402944 14.8971 0 14.4 0C13.9029 0 13.5 0.402944 13.5 0.9C13.5 1.39706 13.0971 1.8 12.6 1.8H5.4C4.90294 1.8 4.5 1.39706 4.5 0.9C4.5 0.402944 4.09706 0 3.6 0C3.10294 0 2.7 0.402944 2.7 0.9C2.7 1.39706 2.29706 1.8 1.8 1.8C0.81 1.8 0 2.61 0 3.6V18C0 18.99 0.81 19.8 1.8 19.8H16.2C17.19 19.8 18 18.99 18 18V3.6C18 2.61 17.19 1.8 16.2 1.8ZM16.2 16C16.2 17.1046 15.3046 18 14.2 18H3.8C2.69543 18 1.8 17.1046 1.8 16V8.3C1.8 7.19543 2.69543 6.3 3.8 6.3H14.2C15.3046 6.3 16.2 7.19543 16.2 8.3V16Z"
      fill="#8b0018"
    />
  </svg>
);
export const ExcelDownloadIcon1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2289.75 2130"
    width="24"
    height="24"
    aria-hidden="true"
  >
    <defs>
      <linearGradient
        id="excelGradient"
        gradientUnits="userSpaceOnUse"
        x1="203.51"
        y1="1729.02"
        x2="967.99"
        y2="404.98"
        gradientTransform="matrix(1 0 0 -1 0 2132)"
      >
        <stop offset="0" stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
    </defs>

    <path
      fill="#185C37"
      d="M1437.75 1011.75 532.5 852v1180.39c0 53.91 43.7 97.61 97.61 97.61h1562.04c53.91 0 97.61-43.7 97.61-97.61V1597.5L1437.75 1011.75z"
    />
    <path
      fill="#21A366"
      d="M1437.75 0H630.11C576.2 0 532.5 43.7 532.5 97.61V532.5L1437.75 1065 1917 1224.75 2289.75 1065V532.5L1437.75 0z"
    />
    <path fill="#107C41" d="M532.5 532.5h905.25V1065H532.5z" />
    <path
      fill="url(#excelGradient)"
      d="M97.61 479.25h976.28c53.91 0 97.61 43.7 97.61 97.61v976.28c0 53.91-43.7 97.61-97.61 97.61H97.61C43.7 1650.75 0 1607.05 0 1553.14V576.86c0-53.91 43.7-97.61 97.61-97.61z"
    />
    <path
      fill="#fff"
      d="M302.3 1382.26 507.63 1064.1 319.5 747.68h151.34l102.67 202.35c9.48 19.22 15.97 33.49 19.49 42.92h1.33c6.75-15.34 13.85-30.23 21.3-44.68L725.37 747.79H864.3l-192.93 314.55L869.2 1382.26H721.38L602.79 1160.16c-5.59-9.45-10.33-19.38-14.16-29.66h-1.76c-3.47 10.07-8.08 19.72-13.74 28.76l-122.1 223.01H302.3z"
    />
    <path
      fill="#33C481"
      d="M2192.14 0H1437.75v532.5h852V97.61C2289.75 43.7 2246.05 0 2192.14 0z"
    />
    <path fill="#107C41" d="M1437.75 1065h852v532.5h-852z" />
  </svg>
);
export const PDFDownloadIcon1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 75.32 92.6"
    width="24"
    height="24"
    aria-hidden="true"
  >
    <g transform="translate(53.55 -183.98) scale(1.4843)">
      <path
        fill="#ff2116"
        d="M-29.63 123.95c-3.55 0-6.44 2.89-6.44 6.45v49.5c0 3.55 2.89 6.45 6.44 6.45H8.22c3.55 0 6.44-2.9 6.44-6.45v-40.7s.1-1.19-.42-2.35c-.48-1.09-1.28-1.84-1.28-1.84l-9.39-9.21s-.8-.76-1.99-1.27c-1.4-.6-2.84-.54-2.84-.54z"
      />

      <path
        fill="#f5f5f5"
        d="M-29.63 126.06h28.38s1.13.01 1.96.37c.8.34 1.37.86 1.37.86l9.37 9.19s.56.6.84 1.21c.22.49.23 1.4.23 1.4v40.75c0 2.42-1.91 4.33-4.33 4.33h-37.85c-2.42 0-4.33-1.91-4.33-4.33V130.39c0-2.42 1.91-4.33 4.33-4.33z"
      />

      <path
        fill="#ff2116"
        d="M-23.41 161.09c-1.46-1.46.12-3.46 4.4-5.58l2.69-1.34 1.05-2.29c.58-1.26 1.44-3.32 1.91-4.57l.86-2.28-.6-1.69c-.73-2.08-.99-5.19-.53-6.32.63-1.52 2.69-1.36 3.51.27.64 1.27.57 3.57-.18 6.48l-.62 2.38.55.93c.3.51 1.18 1.72 1.95 2.69l1.45 1.8 1.8-.24c5.73-.75 7.69.52 7.69 2.34 0 2.3-4.5 2.49-8.28-.16-.85-.6-1.43-1.19-1.43-1.19s-2.37.48-3.53.8c-1.2.32-1.8.53-3.56 1.12 0 0-.62.9-1.02 1.55-1.5 2.43-3.25 4.44-4.5 5.17-1.4.82-2.87.88-3.6.14z"
      />

      <path
        fill="#2c2c2c"
        d="M-20.93 167.84h2.36c.76 0 1.38.07 1.84.22.47.21.87.53 1.19.94.32.49.48 1.07.48 1.76 0 .94-.39 1.62-1.06 1.98-.66.3-1.33.3-2.03.3h-.82v3.73h-1.58zm1.58 1.22v3.33h.78c1.05 0 1.45-.39 1.45-1.27 0-.66-.27-1.06-.59-1.16-.31-.1-1-.1-1.64-.1zm5.51-1.22h2.15c1.56 0 2.49.55 3.38 2.2.48 1.09.48 2.42.48 2.42 0 2.71-1.37 4.93-3.83 4.93h-2.27zm1.58 1.27v7.02h.66c1.38 0 2-.95 2-2.55 0-3.51-2.66-3.51-2.66-3.51zm6.47-1.27h5.3v1.27H-4.21v2.85h2.98v1.27h-2.98v4.16h-1.58z"
      />
    </g>
  </svg>
);
